import {Box, IconButton, Stack, styled} from '@mui/material';

const ImageContainer = styled(Box)`
	width: 100%;
	display: flex;
	justify-content: center;
`;

const StyledImage = styled('img')`
	max-height: 366px;
	object-fit: cover;
	width: 100%;

	${({theme}) => theme.breakpoints.up('sm')} {
		max-height: 350px;
	}
`;

const ContentStack = styled(Stack)<{$isMobile: boolean}>`
	padding: ${({$isMobile}) => ($isMobile ? '16px' : '16px 16px 24px')};
	gap: ${({$isMobile}) => ($isMobile ? '32px' : '0')};
	flex-direction: column;
	flex: 1;
	justify-content: space-between;
`;

const CloseButton = styled(IconButton)`
	position: absolute;
	top: 8px;
	right: 8px;
	background-color: #00000040;
`;

const FooterStack = styled(Stack)`
	flex-direction: row;
	gap: 16px;
	padding: 0 16px 16px;

	${({theme}) => theme.breakpoints.down('sm')} {
		flex-direction: column-reverse;
	}
`;

export {CloseButton, ContentStack, FooterStack, ImageContainer, StyledImage};
